import Div from "../lib/Div";
import {Image} from "react-native";
import P from "../lib/P";
import React from "react";
import WarnIcon from "../assets/img/icons/warn-icon.svg";

const AgeRestrictionWarning = () => {
  return (
    <Div flex={1} justifyContent="space-between" alignItems="center" pb={40}>
      <Div flex={1} justifyContent="center" alignItems="center" p={16}>
        <Div borderWidth={2} borderColor="#F2B824" rounded={12} p={24} alignItems="center">
          <Image source={WarnIcon as any} style={{width: 50.768, height: 45.125, marginBottom: 16}}/>

          <P fontFamily="DavisSans-Regular" ta="center" fs={16} lh={24}>
            You must be 18 or older to play Skill Strike.
          </P>

          <P fontFamily="DavisSans-Regular" ta="center" fs={16} lh={24}>
            If you feel this is an error, please update your date of birth in your profile.
          </P>
        </Div>
      </Div>
    </Div>
  );
};

export default AgeRestrictionWarning;
